import { FunctionInterpolation, Global } from '@emotion/react';
import { Theme } from '@mui/material';

import { FC, useCallback } from 'react';

export const Style: FC = () => {
  const styles = useCallback<FunctionInterpolation<Theme>>(
    theme => ({
      '#root': {
        backgroundColor: theme.palette.grey900.main
      }
    }),
    []
  );

  return <Global styles={styles} />;
};

Style.displayName = 'Style';
